import React from "react";
import styled from "@emotion/styled";

const Container = styled.button`
  background: #0088d2;
  border-radius: 19px;
  border-style: none;
  width: 153px;
  height: 43px;
  overflow: auto;
  font-family: ${props => props.theme.fonts.subheading};
  color: white;
  cursor: pointer;
  font-size: 1rem;

  &:hover a {
    color: white;
  }

  & a:visited {
    color: white;
  }

  :disabled {
    opacity: 0.5;
  }

  svg {
    visibility: hidden;
  }

  div {
    display: inline-block;
  }

  &:hover {
    svg {
      visibility: visible;
      transform: translateX(2px);
      transition: 0.2s;
    }
    div {
      transform: translateX(6px);
      transition: 0.2s;
    }
  }
`;

const Arrow = () => {
  return (
    <svg
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.999999 12L10 6.2381L1 1"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export function AsyncButton(props) {
  const [isLoading, setLoading] = React.useState(false);

  const onClick = () => {
    const afterClick = props.onClick && props.onClick();
    if (!afterClick || typeof afterClick.then !== "function") {
      return;
    }
    setLoading(true);
    const done = () => setLoading(false);
    afterClick.then(done).catch(done);
  };

  return <RoundButton {...props} disabled={isLoading} onClick={onClick} />;
}

export default function RoundButton(props) {
  return (
    <Container {...props}>
      <Arrow />
      <div>{props.children}</div>
    </Container>
  );
}
